import React from "react";

import MyCountdown from "../parts/countdown";
import Form from "../forms/form";
import {IoCalendar} from "react-icons/io5";
import {MdPlace} from "react-icons/md";
import DOMPurify from "dompurify";
import FirstScreenSpeacers from "../parts/firsrtscreen-speacers";

import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';


import GetLogo from "../../img/get_logo.svg";
import HeroDecorLeft from "../../img/decor/hero_decor_left_mob.webp";
import HeroDecorRight from "../../img/decor/hero_decor_right_mob.webp";

import HeroArrowRight from "../../img/decor/arrow-decor.webp";
import HeroArrowLeft from "../../img/decor/arrow-decor.webp";



function FirstScreenSlider({fsData}) {
    const videoId = "AQM29BOyRvI";
    const heroVideoBgUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=0&loop=1&playlist=${videoId}&modestbranding=1&rel=0&playsinline=1&start=3`;

    return (
        fsData ?
            <section className="relative pt-20 md:pt-[155px] lg:pt-[220px]"  id="top">

                <div className="pointer-events-none absolute inset-0 -z-20 overflow-hidden" aria-hidden="true">
                    <iframe
                        className="absolute left-1/2 top-1/2 h-[56.25vw] min-h-full min-w-full w-[177.78vh] -translate-x-1/2 -translate-y-1/2"
                        src={heroVideoBgUrl}
                        title="Background video"
                        frameBorder="0"
                        allow="autoplay; encrypted-media; picture-in-picture"
                        tabIndex="-1"
                    />
                </div>

                <div
                    className="absolute inset-0 -z-10 bg-[linear-gradient(180deg,rgba(250,249,255,0.82)_0%,rgba(250,249,255,0.92)_60%,rgba(250,249,255,0.97)_100%)] opacity-70"
                    aria-hidden="true"
                />

                <div className="absolute hidden lg:block -z-10
                        top-[clamp(70px,calc(70px+90*((100vw-390px)/1530)),160px)]
                        right-[clamp(8px,calc(40px-32*((100vw-390px)/1530)),40px)]
                        w-[clamp(120px,calc(120px+140*((100vw-390px)/1530)),260px)]
                        rotate-180">
                    <img src={HeroArrowRight} className="w-full" alt="logo" />
                </div>

                <div className="absolute hidden lg:block -z-10 hidden xl:block
                        top-[clamp(70px,calc(70px+50*((100vw-390px)/1530)),120px)]
                        left-[clamp(8px,calc(40px-32*((100vw-390px)/1530)),40px)]
                        w-[clamp(120px,calc(120px+140*((100vw-390px)/1530)),260px)]">
                    <img src={HeroArrowRight} className="w-full" alt="logo" />
                </div>

                <div className="hidden lg:block w-[250px] h-[250px] absolute left-0 bottom-0 bg-[#babafe] rounded-tr-[250px]"></div>
                <div className="hidden lg:block w-[250px] h-[250px] absolute right-0 bottom-0 bg-[#babafe]"></div>
                <div className="w-[250px] h-[250px] absolute right-[250px] bottom-[250px] bg-[#babafe] rounded-tr-[250px]
                    hidden xl:block"></div>

                <div className="container max-w-screen-xl mx-auto px-5">

                    <div className="md:flex md:flex-wrap md:items-end md:gap-8 xl:gap-[60px]">

                        <div className="relative md:order-1 md:flex-1 md:w-[calc(50%-16px)] xl:w-[calc(50%-30px)] lg:max-w-[640px]">



                            {/* Лого и дата */}
                            <div className="flex gap-[14px] mb-6 md:mb-8 xl:mb-14 lg:gap-7 xl:gap-10">
                                <div className="w-[clamp(185px,30vw,537px)]">
                                    <img src={GetLogo} className="w-full" alt="logo"/>
                                </div>

                                <div className="relative flex flex-col">
                                    <div className="hidden md:block absolute -z-10
                                        md:-top-[60px] md:-left-[45px]  md:h-[170px] md:w-[170px]

                                      xl:-top-[100px] xl:-left-[75px]  xl:h-[270px] xl:w-[270px] rounded-full bg-[#babafe]" />

                                    <div className="uppercase text-base font-bold tracking-[0.15em] whitespace-nowrap
                                            md:text-xl xl:text-3xl">
                                            {/*<IoCalendar/>*/}
                                            <span>25.11.26</span>
                                        </div>
                                        <div className="uppercase text-base font-bold tracking-[0.15em] whitespace-nowrap
                                            md:text-xl xl:text-3xl">
                                            {/*<MdPlace/>*/}
                                            <span>Київ</span>
                                        </div>
                                </div> 

                            </div>

                            {/* Форма */}

                            <div className="bg-[#babafe] relative z-10 py-5 px-[15px] relative
                                lg:py-6 xl:py-8 lg:px-8 xl:px-14">
                                <div className="hidden lg:block xl:hidden w-[250px] h-[250px] absolute top-0 -right-[249px] bottom-[250px] bg-[#babafe] rounded-tr-[250px]"></div>


                                {/*<div className="mb-4 md:flex md:flex-wrap relative z-10
                                    md:flex-[50%]">
                                    <div className="flex items-center gap-6 mb-1 lg:gap-6">
                                        <div className="flex items-end gap-[5px] py-[6px] px-[22px] bg-[linear-gradient(90deg,#b4f210_0%,#fdf9ae_100%)] rounded-full
                                                ">
                                            <span className="text-3xl font-bold leading-none xl:text-[42px]">2500</span>
                                            <span className="text-xs font-bold">грн*</span>
                                        </div>
                                        <div className="flex items-end relative">
                                            <span className="text-3xl font-bold leading-none xl:text-[42px]">4500</span>
                                            <span className="text-xs font-bold">грн*</span>
                                            <span className="block absolute -left-[8px] top-1/2 -translate-y-1/2
                                                w-[90%] h-[3px] bg-[#b43125] opacity-80 -rotate-6"></span>
                                        </div>
                                    </div>
                                    <p className="text-xs font-light md:flex-[100%]">* Ціна до оподаткування</p>
                                </div>*/}
                                
                                <MyCountdown/>

                                <Form/>

                            </div>
                        </div>



                        <div className="md:order-2 relative  md:w-[calc(50%-16px)] xl:w-[calc(50%-30px)] lg:max-w-[560px]
                            lg:-mt-[100px]">

                            <div className="w-[20vw] md:hidden absolute top-5 -left-5">
                                <img src={HeroDecorLeft} className="w-full" alt="decor"/>
                            </div>
                            <div className="w-[20vw] md:hidden absolute top-5 -right-5">
                                <img src={HeroDecorRight} className="w-full" alt="decor"/>
                            </div>

                            <FirstScreenSpeacers slider_data={fsData.fs_speacers_slider}/>

                            
                        </div>


                        <div className="md:order-2 relative  md:w-[calc(50%-16px)] xl:w-[calc(50%-30px)] lg:max-w-[560px]
                            lg:-mt-[100px] max-lg:my-10">

                            <div className="w-[20vw] md:hidden absolute top-5 -left-5">
                                <img src={HeroDecorLeft} className="w-full" alt="decor"/>
                            </div>
                            <div className="w-[20vw] md:hidden absolute top-5 -right-5">
                                <img src={HeroDecorRight} className="w-full" alt="decor"/>
                            </div>

                            {/* <div className="relative w-full overflow-hidden pt-[56.25%] shadow-lg">
                                <iframe
                                    className="absolute inset-0 h-full w-full"
                                    src={heroVideoUrl}
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                />
                            </div> */}
                            
                        </div>
                    </div>

                </div>

            </section>
        : ''
    )
}

export default FirstScreenSlider